export default __webpack_public_path__ + "static/JOeDBJSA-b15bfeb63d8381b63973169f3dbaffc3.svg";